"use client";

import {createContext, useMemo, type ReactNode} from "react";
import {useOrg} from "@/hooks/useOrg";

export const ApprovalLookupBudgetContext = createContext<(() => boolean) | undefined>(undefined);

/** Optional live labels share the documented eight-request budget for one review. Required targets never spend it. */
export function ApprovalLookupBudgetProvider({children}: {children: ReactNode}) {
   const {org} = useOrg();
   const reserveLookup = useMemo(() => {
      let remaining = 8;
      // Reserve in the lookup effect, only when starting a new request.
      return () => {
         if (!remaining) return false;
         remaining--;
         return true;
      };
   }, [org?.id]);
   return <ApprovalLookupBudgetContext.Provider value={reserveLookup}>{children}</ApprovalLookupBudgetContext.Provider>;
}
